unable to read source [project]/node_modules/@finbackoffice/enums/src/blue-ocean.ts